import { Button, message, Table } from "antd";
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FC, useEffect, useState } from "react";
import { notification } from 'antd';
import moment from "moment-jalaali";
import Actions from "../actions";
import { useNavigate } from "react-router-dom";
import restful from "../../restful";

interface DataType {
    user: String
    creditPack: String
    cost: number
    token: String
    paidAt: Date
    usedAt: Date

    _id: String
    createdAt: Date
    updatedAt: Date
}

interface Params { page?: number; perPage?: number, sortDir: string, sort: string }

const InvoicesTable: FC<{ filters: any }> = ({ filters }) => {
    const navigate = useNavigate()
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [items, setItems] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: 10,
    });

    const onDeleteAction = (id: string) => {
        restful.delete('/invoices/' + id)
            .then((res) => {
                fetchData({ sortDir: "desc", sort: "createdAt", page: pagination.current, perPage: pagination.pageSize })
            })
            .catch((err) => message.error(err.message));
    }


    const onSyncClick = (id: string) => {
        restful.put('/invoices/' + id + '/sync')
            .then((res) => {
                fetchData({ sortDir: "desc", sort: "createdAt", page: pagination.current, perPage: pagination.pageSize })
            })
            .catch((err) => message.error(err.message));
    }

    const columns: ColumnsType<DataType> = [
        {
            sorter: true, title: 'کاربر', dataIndex: 'user', key: 'user',
            render(val) { return val?.name }
        },
        {
            sorter: true, title: 'پکیج', dataIndex: 'creditPack', key: 'creditPack',
            render(val) { return val?.title }
        },
        {
            sorter: true, title: 'مبلغ', dataIndex: 'cost', key: 'cost',
            render(val) { return val?.toLocaleString() }
        },
        { sorter: true, title: 'توکن خرید', dataIndex: 'token', key: 'token' },

        {
            sorter: true, title: 'پرداخت', dataIndex: 'paidAt', key: 'paidAt', width: 110,
            render(val) {
                if (!val) return ""
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },
        {
            sorter: true, title: 'استفاده', dataIndex: 'usedAt', key: 'usedAt', width: 110,
            render(val) {
                if (!val) return ""
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },

        {
            defaultSortOrder: 'descend',
            sorter: true, title: 'زمان ایجاد', dataIndex: 'createdAt', key: 'createdAt', width: 110,
            render(val) {
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },
        {
            sorter: true, title: 'بروزرسانی', dataIndex: 'updatedAt', key: 'updatedAt', width: 110,
            render(val) {
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },
        {
            title: 'عملیات', dataIndex: '_id', key: '_id', width: 100,
            render(val, data) {
                return <Button onClick={() => onSyncClick(val)} disabled={!(data.paidAt!=null && data.usedAt==null)}>همگام سازی</Button>
            }
        }

    ];

    const fetchData = (params: Params) => {
        setIsLoaded(true);
        restful.get(`/invoices/paginate`, { params: { ...params, ...filters } })
            .then((res) => {
                const result = res.data.result
                setItems(result.invoices);
                setPagination({
                    current: params.page,
                    pageSize: params.perPage,
                    total: result.invoicesCount,
                })
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData({ sortDir: "desc", sort: "createdAt", page: pagination.current, perPage: pagination.pageSize });
    }, [filters])

    const handleTableChange = (newPagination: TablePaginationConfig, filter: any, sorter: any) => {
        if (pagination.pageSize !== newPagination.pageSize) newPagination.current = 1
        fetchData({
            page: newPagination.current,
            perPage: newPagination.pageSize,
            sortDir: sorter.order === "ascend" ? "asc" : "desc",
            sort: sorter.field ?? "createdAt"
        });
    };

    return <Table
        columns={columns}
        dataSource={items}
        loading={isLoaded}
        rowKey="_id"
        pagination={pagination}
        onChange={handleTableChange}
    />
}

export default InvoicesTable
